// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '@/store/index'

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Наименование',
        isSortable: false
      }
    ]
  },
  types: [],
  modal: {
    active: false,
    updatedId: null,
    name: '',
    validation: {
      name: { type: null, message: '' }
    }
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  isActiveDelete: false
})

const getters = {
  getContractorsTypeList: state => state.types,
  getContractorsTypeListTableHeaders: state => state.tableHeaders,
  getContractorsTypeListModal: state => state.modal,
  getContractorsTypeListSearchValue: state => state.searchValue,
  getContractorsTypeListFilter: state => state.filter,
  getContractorsTypeListPagination: state => state.pagination,
  getContractorsTypeListIsLoading: state => state.isLoading,
  getContractorsTypeListResponseModal: state => state.responseModal,
  getContractorsTypeListResponseModalWithTreaties: state => state.responseModalWithTreaties,
  getContractorsTypeListActiveDelete: state => state.isActiveDelete
}

const mutations = {
  GET_CONTRACTORS_TYPE: (state, types) => {
    state.types = types.map(type => {
      return {
        ...type,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  TOGGLE_CONTRACTORS_TYPE_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.types.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  TOGGLE_CONTRACTORS_TYPE_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.types.length
    let counter = 0

    state.types.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_CONTRACTORS_TYPE_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.types.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  SHOW_CONTRACTORS_TYPE_LIST_MODAL: (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedType = state.types.filter(type => {
        return type.id === itemId
      }).pop()

      state.modal.updatedId = itemId
      state.modal.name = selectedType.name
    }
  },
  SET_CONTRACTORS_TYPE_ITEM_NAME: (state, value) => {
    state.modal.name = value
  },
  SET_CONTRACTORS_TYPE_ITEM_FULL_NAME: (state, value) => {
    state.modal.fullName = value
  },
  SET_CONTRACTORS_TYPE_ITEM_VALIDATION: (state, valid) => {
    state.modal.validation.name.message = valid
    state.modal.validation.name.type = 'error'
  },
  CLEAR_CONTRACTORS_TYPE_MODAL_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = { type: null, message: '' }
        break
      default:
        break
    }
  },
  CLOSE_CONTRACTORS_TYPE_LIST_MODAL: (state) => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.validation.name = { type: null, message: '' }
  },

  // pagination
  SET_CONTRACTORS_TYPE_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  RESET_CONTRACTORS_TYPE_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },

  // search
  SET_CONTRACTORS_TYPE_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  TOGGLE_CONTRACTORS_TYPE_LIST_FILTER: (state) => {
    state.filter.active = !state.filter.active
  },

  // delete checked items
  DELETE_CONTRACTORS_TYPE_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили тип(ы)'
    state.responseModal.type = 'main'
  },
  DELETE_CONTRACTORS_TYPE_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении типа произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },

  DELETE_CONTRACTORS_TYPE_LIST_CHECKED_ITEMS_TREATIES_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModalWithTreaties.isActive = true
    state.responseModalWithTreaties.text = `Данные типы используются в контрагентах:${listNamesErrorItems}`
    state.tableHeaders.allActive = false
  },
  CLOSE_DELETE_CONTRACTORS_TYPE_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  CLOSE_DELETE_CONTRACTORS_TYPE_LIST_MODAL_WITH_TREATIES: (state) => {
    state.responseModalWithTreaties.isActive = false
    state.responseModalWithTreaties.text = ''
  },
  RESET_CONTRACTORS_TYPE_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.types.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  // reset store
  RESET_CONTRACTORS_TYPE_LIST_STORE: (state) => {
    state.searchValue = ''
    state.pagination.currentPage = 1
  }
}

const actions = {
  getContractorsType ({ commit, state }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''

    axios.get(`${url}/partner-type?expand=partners&${searchFilter}&take=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTORS_TYPE', response.data.data)
      commit('SET_CONTRACTORS_TYPE_LIST_PAGINATION', response.headers)
    }).catch(error => {
      console.log('ошибка получения списка контрагентов', error)
    })
  },
  saveContractorsTypeItem ({ commit, state, dispatch }) {
    if (!state.modal.updatedId) {
      const createData = {
        name: state.modal.name
      }
      axios.post(`${url}/partner-type`, createData, config).then(response => {
        commit('CLOSE_CONTRACTORS_TYPE_LIST_MODAL')
        dispatch('getContractorsType')
      }).catch(error => {
        commit('SET_CONTRACTORS_TYPE_ITEM_VALIDATION', error.response.data.errors.name[0])
        console.log('Ошибка обновления договора', error.response)
      })
    } else {
      const updateData = {
        name: state.modal.name
      }

      axios.put(`${url}/partner-type/${state.modal.updatedId}`, updateData, config).then(response => {
        commit('CLOSE_CONTRACTORS_TYPE_LIST_MODAL')
        dispatch('getContractorsType')
      }).catch(error => {
        commit('SET_CONTRACTORS_TYPE_ITEM_VALIDATION', error.response.data.errors.name[0])
        console.log('Ошибка обновления договора', error.response)
      })
    }
  },
  toggleContractorsTypeListItemControls ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTORS_TYPE_LIST_ITEM_CONTROLS', itemId)
  },
  toggleContractorsTypeListItemActive ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTORS_TYPE_LIST_ITEM_ACTIVE', itemId)
  },
  toggleContractorsTypeListItemActiveAll ({ commit }) {
    commit('TOGGLE_CONTRACTORS_TYPE_LIST_ITEM_ACTIVE_ALL')
  },
  showContractorsTypeModal ({ commit }, itemId) {
    commit('SHOW_CONTRACTORS_TYPE_LIST_MODAL', itemId)
  },
  setContractorsTypeItemName ({ commit }, value) {
    commit('SET_CONTRACTORS_TYPE_ITEM_NAME', value)
  },
  clearContractorsTypeModalValidation ({ commit }, inputName) {
    commit('CLEAR_CONTRACTORS_TYPE_MODAL_VALIDATION', inputName)
  },
  closeContractorsTypeModal ({ commit }) {
    commit('CLOSE_CONTRACTORS_TYPE_LIST_MODAL')
  },
  removeContractorsType ({ dispatch }, itemId) {
    axios.delete(`${url}/partner-type/${itemId}`, config).then(response => {
      dispatch('getContractorsType')
    }).catch(error => {
      console.log('Ошибка удаления статуса:' + error)
    })
  },

  // delete checked items
  deleteContractorsTypeListCheckedItems ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    const treatiesItems = []

    state.types.forEach((e) => {
      if (e.isActive && e.partners === null) {
        checkedItems.push(e)
      } else if (e.isActive && e.partners.length > 0) {
        treatiesItems.push(e)
      }
    })

    if (treatiesItems.length > 0) {
      commit('DELETE_CONTRACTORS_TYPE_LIST_CHECKED_ITEMS_TREATIES_ERROR', treatiesItems)
      commit('RESET_CONTRACTORS_TYPE_LIST_ALL_CHECKS')

      treatiesItems.forEach((e) => {
        e.isActive = false
      })
    }

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/partner-type/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления статуса', error)
        })
      }
    }

    if (checkedItems.length > 0) {
      processMessages(checkedItems).then(() => {
        if (errorItems.length > 0) {
          commit('RESET_CONTRACTORS_TYPE_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTORS_TYPE_LIST_CHECKED_ITEMS_ERROR', errorItems)
          dispatch('getContractorsType')
        } else {
          commit('RESET_CONTRACTORS_TYPE_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTORS_TYPE_LIST_CHECKED_ITEMS_SUCCESS')
          dispatch('getContractorsType')
        }
      })
    }
  },
  closeContractorsTypeListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTORS_TYPE_LIST_MODAL')
  },

  // pagination
  getContractorsTypeListPage ({ state, commit }, pageNum) {
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''
    const currentTake = state.pagination.currentTake
    const currentPage = pageNum

    axios.get(`${url}/partner-type?${searchFilter}&orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage - 1}`, config).then(response => {
      commit('GET_CONTRACTORS_TYPE', response.data.data)
      commit('SET_CONTRACTORS_TYPE_LIST_PAGINATION', response.headers)
      commit('CLOSE_CONTRACTORS_TYPE_LIST_PAGE_LIST')
    })
  },
  resetContractorsTypeListCurrentPage ({ commit }) {
    commit('RESET_CONTRACTORS_TYPE_LIST_CURRENT_PAGE')
  },

  // search
  setContractorsTypeListSearchValue ({ commit, dispatch }, searchValue) {
    commit('SET_CONTRACTORS_TYPE_LIST_SEARCH_VALUE', searchValue)
    commit('RESET_CONTRACTORS_TYPE_LIST_CURRENT_PAGE')
    dispatch('getContractorsType')
  },
  closeContractorsTypeListDeleteModalWithTreaties ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTORS_TYPE_LIST_MODAL_WITH_TREATIES')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
